<template>
    <section class="section section-shaped section-lg my-0">
       <div class="shape shape-style-1 bg-gradient-default">
             <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
        </div>
        <div class="container">
            <div class="row row-grid justify-content-center">
                <div class="col-lg-8 text-center text-white">
                    <h2 class="display-3 text-white">Magicom is growing. Work with us.
                    </h2>
                    <p class="lead">Join us to promote the in-depth development of artificial intelligence.</p>
                    <div class="btn-wrapper">
                        <router-link to="/careers" class="text-success">Learn More <i class="fa fa-angle-double-right fa-lg"></i></router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
